import { EventEmitter } from 'events';
import Dispatcher from '../dispatcher';
import ActionTypes from '../constants';
import * as Cart from '../libraries/Cart.js';

const CHANGE = 'CHANGE';

class MainStore extends EventEmitter {
	constructor() {
    super();

    Dispatcher.register(this._registerToActions.bind(this));
    
    this.discounts = [];
    this.items_discounts_map = {};
    this.cart = null;
    this.saved = 0;
    this.total = 0;
    this.total_original = 0;
    this.items = 0;
    this.cart_items_for_checkout = 0;
    this.submitting = false;
    this.has_wholesale_item = false;
    this.has_discount_item = false;
    this.try_add_free_item_fails = 0;
    this.attemp_fails = 0;

    //this.cart = window.__cart;
    //console.log( this.cart );
  }

  // Switches over the action's type when an action is dispatched.
  _registerToActions(action) {
    switch(action.actionType) {
      case ActionTypes.CART_CHANGE:
        this._cartChange(action.payload);
      break;
      case ActionTypes.PRODUCT_UPDATE:
        Cart._productUpdate(action.payload);
      break;
      default:
      break;
    }
  }

  _cartChange = (item) =>{
    this.changed();
  };

  changed = () =>{
    Cart.calculate();
    this.emit(CHANGE);
    //Trigger:
    var event = new CustomEvent("__cart_changed", {detail: this.total});
    window.dispatchEvent(event);
  }

  // Hooks a React component's callback to the CHANGED event.
  addChangeListener = (callback) => {
    this.on(CHANGE, callback);
  };

  // Removes the listener from the CHANGED event.
  removeChangeListener = (callback) => {
    this.removeListener(CHANGE, callback);
  };
}

export default new MainStore();